// Off hours: the student's local time is outside the team call window. Tasks are
// created at any hour, so the list grays these rows and contact actions confirm.
import { callEligibility, formatLocalTime, resolveCallWindow } from './local_time';
import type { CallWindow } from './local_time';

export interface OffHoursInfo {
  // The student's wall clock now, e.g. "9:45 PM".
  time: string;
  // The window as labels, e.g. "8:00 AM" / "9:30 PM".
  start: string;
  end: string;
}

export type ContactAction = 'call' | 'sms' | 'whatsapp' | 'chat';

// '21:30' -> '9:30 PM'; the input is a resolved HH:MM.
export function clockLabel(hhmm: string): string {
  const [h, m] = hhmm.split(':').map(Number);
  const suffix = h < 12 ? 'AM' : 'PM';
  const hour = h % 12 === 0 ? 12 : h % 12;
  return `${hour}:${String(m).padStart(2, '0')} ${suffix}`;
}

// null = inside the window, or no usable zone (unknown zone never grays or confirms).
export function offHours(
  zone: string | null | undefined,
  now: number | Date,
  callWindow?: CallWindow | null
): OffHoursInfo | null {
  if (callEligibility(zone, now, callWindow) !== 'not_eligible') return null;
  const time = formatLocalTime(zone, now);
  if (!time) return null;
  const { start, end } = resolveCallWindow(callWindow);
  return { time, start: clockLabel(start), end: clockLabel(end) };
}

export function offHoursTooltip(info: OffHoursInfo): string {
  return `Off hours for the student (${info.time} in their time zone) — outside ${info.start}–${info.end}`;
}

export function offHoursConfirmCopy(action: ContactAction): {
  question: string;
  confirm_label: string;
} {
  const verb = action === 'call' ? 'Call' : 'Message';
  return {
    question: `Outside the student's calling hours. ${verb} anyway?`,
    confirm_label: `${verb} anyway`
  };
}
